import {Fragment, type FunctionComponent} from 'react'
import {useOutletContext, useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {RootAndListContext, RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'

const BuyingGuide: FunctionComponent = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const {
    dataResponse: {buyingGuide, productsCategory},
  } = useOutletContext<RootAndListContext>()
  const translations = getTranslation(language)

  const isContentExist = buyingGuide && buyingGuide.content
  const isGuidanceExist = isContentExist && buyingGuide.content?.generalGuidance
  const isKeyExist = isContentExist && !!buyingGuide.content.keys?.length

  return isContentExist ? (
    <div className={clsx('flex flex-col justify-center py-12 text-base font-normal leading-7')}>
      <div>
        <h2 key="bg-title" className="mb-5 mt-2 text-3xl font-bold tracking-normal">
          {translations.BuyingGuide.title(productsCategory?.name)}
        </h2>

        {isGuidanceExist && (
          <span className="mb-4 mt-2 text-base font-normal leading-7">{buyingGuide.content?.generalGuidance}</span>
        )}
        {isKeyExist
          ? buyingGuide.content.keys?.map(({explanation, name}) => (
              <Fragment key={name}>
                <div className="mt-5 flex flex-col gap-2">
                  <span className="text-2xl font-bold">{name}</span>
                  <span className="text-base leading-7">{explanation}</span>
                </div>
              </Fragment>
            ))
          : null}
      </div>
    </div>
  ) : null
}

export default BuyingGuide
